// import { uploadFile, uploadImagesForPointClouds } from "api/fileManager";

const fileUploaderApiConfig = {
  uploadFile: () => null,
  uploadImagesForPointClouds: () => null
};

export default fileUploaderApiConfig;